import React, { Component } from "react";
import "./Link.css";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

export default class LinkHelper extends Component {

    render() {
        const Container = this.props.component || "span";
        const Content = (
            <Link to={this.props.to}>
                {this.props.children}
            </Link>
        );
        if ( this.props.disabled ) {
            return (
                <Container className={this.props.styleName ? this.props.styleName : ( this.props.bare ? "Link-bare" : "Link" )}>
                    {this.props.children}
                </Container>
            );
        }
        else {
            return (
                <Container className={this.props.styleName ? this.props.styleName : ( this.props.bare ? "Link-bare" : "Link" )}>
                    {Content}
                </Container>
            );
        }
    }

}

LinkHelper.propTypes = {
    to: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    disabled: PropTypes.bool,
    styleName: PropTypes.string,
    component: PropTypes.any,
    bare: PropTypes.bool
}